// Action creators extracted from PusherModule.js

import { HANDLE_FOCUSED_FIELD, INIT_LOCKED_FIELD } from "./PusherConstants";

// Action Creators
export const initLockedFields = data => {
  return { type: INIT_LOCKED_FIELD, data };
};

export const handleFocuedField = data => {
  return { type: HANDLE_FOCUSED_FIELD, data };
};
